import * as elementsAPI from '@motionelements/core/src/api/elements.js';
import { isProductType } from '@motionelements/core/src/services/catalog.service.js';

export default {
  fetchOnServer: true,
  data() {
    return {
      productSku: null,
    };
  },
  computed: {
    productId() {
      return _.get(this.$route.query, 'sku');
    },
  },
  watch: {
    '$route.query.sku'(val) {
      if (!val) {
        this.$store.commit('tool/setProduct', null);
      }
    },
  },
  mounted() {
    if (this.productId) {
      this.getProductInfo();
    }
  },
  methods: {
    getProductInfo() {
      this.isLoading = true;
      return elementsAPI.getElement(this.productId)
        .then(({ data: { data: product } }) => {
          this.$store.commit('tool/setProduct', _.pick(product, ['html']));
          switch (this.form.model) {
            case 'video_upscale_2x':
            case 'video_upscale_4x':
              this.handleVideoUpscaler(product);
              break;
            case 'music_duration':
              this.handleMusicDurationAdjuster(product);
              break;
            case 'image_remove_background':
            case 'image_variation':
            case 'image_to_video':
            case 'image_face_swap':
              this.handleImageProduct(product);
              break;
            // no default
          }
          if (this.$route.path.includes('/style-transfer')) {
            this.handleImageProduct(product);
          }
        })
        .catch((err) => {
          console.error(err);
          this.isError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    handleVideoUpscaler(product) {
      if (isProductType('video', _.get(product, 'mediaType', ''))) {
        // this.inputFilePreview = 'https://thumb.r2.moele.me/t/1322/9312315/a-0200.jpg';
        // this.form.video = 'https://video.r2.moele.me/v/1322/9312315_a-01.mp4';
        this.inputFilePreview = _.get(product, 'thumbnails.jpg.url', '');
        this.form.video = _.get(product, 'previews.mp4.url', '');
        this.width = _.get(product, 'variants[0].width', 0);
        this.height = _.get(product, 'variants[0].height', 0);
        this.duration = _.get(product, 'variants[0].duration', 0);
        //
        const masterVariant = _.get(product, 'variants', []).find(({ master }) => master);
        this.productSku = _.get(masterVariant, 'id');
      } else {
        console.error('%c CURRENT PRODUCT IS NOT A VIDEO!', 'color: red');
        this.isError = true;
      }
    },
    handleMusicDurationAdjuster(product) {
      if (isProductType('music', _.get(product, 'mediaType', ''))) {
        this.form.audio = _.get(product, 'previews.mp3.url', '');
      } else {
        console.error('%c CURRENT PRODUCT IS NOT A MUSIC!', 'color: red');
        this.isError = true;
      }
    },
    handleImageProduct(product) {
      if (isProductType('image', _.get(product, 'mediaType', ''))) {
        if (this.form.model === 'image_face_swap') {
          this.form.targetImage = _.get(product, 'previews.jpg.url', '');
        } else {
          this.form.image = _.get(product, 'previews.jpg.url', '');
        }
      } else {
        console.error('%c CURRENT PRODUCT IS NOT AN IMAGE!', 'color: red');
        this.isError = true;
      }
    },
  },
};
